<template>
  <div>
    <el-form
      ref="formData"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_metadata_type') || '属性类型'"
            prop="metadataType"
          >
            <el-input
              clearable
              v-model="formData.metadataType"
              :placeholder="
                $l('form_label_pe_metadata_type') || '请输入属性类型'
              "
              disabled
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_option_name') || '备选项名称'"
            prop="optionName"
          >
            <el-input
              clearable
              v-model="formData.optionName"
              :placeholder="
                $l('form_label_pe_option_name') || '请输入备选项名称'
              "
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_option_name_en') || '备选项英文名称'"
            prop="optionNameEn"
          >
            <el-input
              clearable
              v-model="formData.optionNameEn"
              :placeholder="
                $l('form_label_pe_option_name_en') || '请输入备选项英文名称'
              "
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_option_full_name') || '备选项完整显示文字'"
            prop="optionFullName"
          >
            <el-input
              clearable
              v-model="formData.optionFullName"
              :placeholder="
                $l('form_label_pe_option_full_name') ||
                  '请输入备选项完整显示文字'
              "
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="
              $l('form_label_option_full_name_en') || '备选项完整显示文字英文'
            "
            prop="optionFullNameEn"
          >
            <el-input
              clearable
              v-model="formData.optionFullNameEn"
              :placeholder="
                $l('form_label_pe_option_full_name_en') ||
                  '请输入备选项完整显示文字英文'
              "
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_status') || '有效状态'"
            prop="optionStatus"
          >
            <br />
            <el-radio-group v-model="formData.optionStatus">
              <el-radio label="Y">{{
                $l('INDEX.form_label_valid') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('INDEX.form_label_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_option_level') || '备选项层级'"
            prop="optionLevel"
            size="small"
          >
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.optionLevel"
              :step="1"
              :precision="0"
              :min="0"
              :max="9999999"
              controls-position="right"
              :placeholder="$l('form_label_pe_option_level') || '请输入备选项层级'"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row> -->
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    optionCode: String,
    metadataType: String,
    upOptionCode: String
  },
  components: {},
  data() {
    return {
      backDialogVisible: false,
      formData: {
        optionStatus: 'Y',
        metadataType: '',
        upOptionCode: '',
        optionLevel: 1
      },
      rules: {
        metadataType: [
          {
            required: true,
            message: this.$l('form_label_pe_metadata_type') || '请输入属性类型',
            trigger: 'blur'
          }
        ],
        optionName: [
          {
            required: true,
            message: this.$l('form_label_pe_option_name') || '请输入备选项名称',
            trigger: 'blur'
          }
        ],
        optionNameEn: [
          {
            required: true,
            message:
              this.$l('form_label_pe_option_name_en') || '请输入备选项英文名称',
            trigger: 'blur'
          }
        ],
        optionFullName: [
          {
            required: true,
            message:
              this.$l('form_label_pe_option_full_name') ||
              '请输入备选项完整显示文字',
            trigger: 'blur'
          }
        ],
        optionFullNameEn: [
          {
            required: true,
            message:
              this.$l('form_label_pe_option_full_name_en') ||
              '请输入备选项完整显示文字英文',
            trigger: 'blur'
          }
        ],
        optionLevel: [
          {
            required: true,
            message:
              this.$l('form_label_pe_option_level') || '请输入备选项层级',
            trigger: 'change'
          }
        ],
        optionStatus: [
          { required: true, message: '请选择有效状态', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.setParentData()
    this.getDate()
  },
  methods: {
    getDate() {
      if (!this.optionCode) return
      this.$api
        .sampleMetadataOptionsDetailApi({
          optionCode: this.optionCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    //设置父组件传过来的matadataType值
    setParentData() {
      if (this.optionCode) return
      console.log(this.upOptionCode)
      this.formData.metadataType = this.metadataType
      this.formData.upOptionCode = this.upOptionCode
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .sampleMetadataOptionsSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success'
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    }
  }
}
</script>
